import './form-hidden-calendar.scss';
import { Calendar, InputHidden } from '../../../components';
import { useInput, useFormContext } from '../../../features/auto-form';
import { useEffect, useLayoutEffect, useState } from 'react'

const DATE_LOCAL_MAP = {
    "se": "en-US",//"sv-SE",
    "en": "en-US",
    "dk": "da-DK",
    "no": "no-NO",
    "fi": "fi-FI"
}

const market = "se" // TODO: get from props

const FormHiddenCalendar = (props) => {
    const [textValue, setTextValue] = useState("")

    const handleDateChange = (e) => {
        const {value} = e.target
        let tempText = ``
        if (value) {
            let date = new Date(value)
            tempText = new Intl.DateTimeFormat(DATE_LOCAL_MAP[market]).format(date)//`${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
            //console.log(tempText)
        }
        setTextValue(tempText)
        if (props.onChange) {
            props.onChange(e)
        }
    }

    const {
        ref,
        bind
    } = useInput({...props, onChange: handleDateChange})


    const onReset = () => {

    }
  


    const { register, deregister } = useFormContext()

    useLayoutEffect(() => {

        if (!props.ignore) {
            // Register as ref in form on mount
            register(props.id || props.name, ref)

            // Deregister as ref in form on unmount
            return () => {
                deregister(props.id || props.name)
            }
        }
    }, [])

    useEffect(() => {
        if (bind.value === "") {
            setTextValue("")
        }

    }, [bind.value])


    return (
        <InputHidden {...props} /*onReset={onReset}*/ value={textValue} trailingIcon={props.icon || "calendar"} onReset={() => onReset()} disabled={props.disabled}>
            <div className='calendar-content' >
            <Calendar 
            {...props}
            disabled={false}
            label=""
            {...bind}
            />
            </div >
        </InputHidden>
    )
}

export default FormHiddenCalendar;  